import groupsTrainers from '@/store/modules/groups-trainers/groups-trainers'
import groupsTrainersAll from '@/store/modules/groups-trainers/groups-trainers-all'
import groupsTrainersCreate from '@/store/modules/groups-trainers/groups-trainers-create'
import groupsTrainersDelete from '@/store/modules/groups-trainers/groups-trainers-delete'

export default {
  groupsTrainers,
  groupsTrainersCreate,
  groupsTrainersDelete,
  groupsTrainersAll
}
